import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Message, Select } from "@components";
import { Toggle } from "shared/components/Toggle";

export default class GooglePayDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      active: false,
      environment: "PRODUCTION",
      partnerId: null,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const currentConfigs = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "google_pay"
    );
    const configs = currentConfigs || {};

    if (Object.keys(configs).length > 0) {
      this.setState({
        environment: configs?.environment || "SANDBOX",
        merchantId: configs?.merchantId,
        merchantName: configs?.merchantName,
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { environment, merchantId, merchantName } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const currentConfigs =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "google_pay"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "google_pay",
        {
          google_pay: {
            ...currentConfigs,
            environment,
            merchantId,
            merchantName,
          }
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, environment, merchantId, merchantName } = this.state;
    const { visible, onClose } = this.props;

    const isValid = environment;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Google Pay"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Message className="mb-20" type="warning">
              <p>
                Integração disponível apenas através da <b>Pagar.me</b>.
              </p>
            </Message>

            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Código do estabelecimento (MerchantId)"
              value={merchantId}
              onChange={(e) => this.setState({ merchantId: e.target.value })}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Nome do estabelecimento (MerchantName)"
              value={merchantName}
              onChange={(e) => this.setState({ merchantName: e.target.value })}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
